import { type FC, useEffect } from 'react';
import styles from '../styles/product-selection.module.scss';
import type { Product, ProductGroupItem, RepairBookingSession } from '../models/repair-bookings';
import PageTitle from '../components/page-title';
import ActionButton from '../components/action-button';
import useProductGroup from '../hooks/use-product-group';

const ProductSelection: FC<{
    session: RepairBookingSession;
    groupKey: string;
    onNext: (groupKey: string) => void;
    onComplete: (product: Product) => void;
    onCancel: () => void;
}> = ({ session, groupKey, onNext, onComplete, onCancel }) => {
    const { group, config, error } = useProductGroup(session, groupKey);

    const onSelect = (item: ProductGroupItem) => {
        if (item.group_key) {
            onNext(item.group_key);
        }
        if (item.product) {
            onComplete({ id: item.id, name: item.product.name, sku: item.product.sku });
        }
    };

    useEffect(() => {
        if (error) {
            alert(error.message);
        }
    }, [error]);

    return (
        <div className={styles.productSelection}>
            {group ? (
                <>
                    <PageTitle title={config.title} />
                    <div className={config.type === 'grid' ? styles.gridSelect : styles.listSelect}>
                        {group.options.map((item) => (
                            <div
                                key={item.id}
                                className={styles.item}
                                onClick={() => onSelect(item)}
                            >
                                {item.color && (
                                    <span
                                        className={styles.colorSwatch}
                                        style={{ backgroundColor: item.color }}
                                        title={item.color}
                                    />
                                )}
                                {item.name}
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <p>選択可能な項目が見つかりません</p>
            )}
            <ActionButton
                className={styles.backButton}
                title="戻る"
                primary={false}
                onClick={onCancel}
            />
        </div>
    );
};

export default ProductSelection;
